import { useCacheStorage } from '@/shared/lib/hooks/use-cache-storage';
import { CITypeListItem } from '@/entities/srm/ci';
import { ciTypesListQueryConfig } from './ci-type-query-config';

export const useCITypeListStorage = () => {
  return useCacheStorage<CITypeListItem[]>({
    queryConfig: ciTypesListQueryConfig,
  });
};